import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  UT_LIST,
  CREATE_FD_RESULT,
  GET_VIEW_FD, GET_CLAIM_DATA, BACK_TO_MODIFICATION,
  VERIFY_INVOICE_NUMBERS,
  EDIT_CLIENT_DETAILS
} from './type';

export const fetchUnclaimedList = (filterData = null, page = 1) => async (
  dispatch
) => {
  dispatch({
    type: UT_LIST,
    payload: null,
  });
  let filterQuery = '';
  if (filterData !== null) {
    filterQuery = `?page=${page}`;
    if (filterData?.transaction_id) {
      filterQuery = filterQuery + `&transaction_id=${filterData.transaction_id}`;
    }
    if (filterData?.transaction_amt) {
      filterQuery = filterQuery + `&transaction_amt=${filterData.transaction_amt}`;
    }
    if (filterData?.trans_date) {
      filterQuery = filterQuery + `&trans_date=${filterData.trans_date}`;
    }
    if (filterData?.status) {
      filterQuery = filterQuery + `&status=${filterData.status}`;
    }
    if (filterData?.eligible_for_modification) {
      filterQuery = filterQuery + `&eligible_for_modification=${filterData.eligible_for_modification}`;
    }
    if (filterData?.payment_ref) {
      filterQuery = filterQuery + `&payment_ref=${filterData.payment_ref}`;
    }
    if (filterData?.mode_collection) {
      filterQuery = filterQuery + `&mode_collection=${filterData.mode_collection}`;
    }
    if (filterData?.description) {
      filterQuery = filterQuery + `&description=${filterData.description}`;
    }
  } else {
    filterQuery = `?page=${page}`;
  }
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.postSales.getUnclaimedList}${filterQuery}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: UT_LIST,
      payload: data.response.data,
    });
    return true;
  }
};

export const saveFdTicket = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileComplain.createFdTickets
  );
  /* if (res) {
    const { data } = res;
    dispatch({ type: REOPEN_COMPLAIN, payload: data.response.data });
    return true;
  } */
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const viewDetails = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.fileComplain.viewFdTicketDetails}?id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_VIEW_FD, payload: data.response.data });
    return true;
  }
};

export const viewClaimDetails = (pay_ref) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.postSales.getClaimData}?pay_ref=${pay_ref}`
  );
  if (res) {
    const payload = res.data?.response?.data ?? res.data?.data;
    dispatch({ type: GET_CLAIM_DATA, payload });
    return true;
  }
};

export const modificationRequest = (data) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.postSales.unclaimedSendToModification}`
  );
  if (res) {
    const payload = res.data?.response?.data ?? res.data?.data;
    dispatch({ type: BACK_TO_MODIFICATION, payload });
    return payload;
  }
};

export const verifyInvoicesNumbers = (data) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.postSales.verifyInvoiceNumbers}`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    dispatch({ type: VERIFY_INVOICE_NUMBERS, payload });
    if (outer?.status === 0 || payload?.status === true) {
      return {
        status: true,
        message: payload?.message ?? outer?.message,
        data: payload?.data ?? outer?.data,
      };
    }
    return {
      status: false,
      message: payload?.message ?? outer?.message,
      data: payload?.data ?? outer?.data,
    };
  }
};
export const editClientDetails = (data) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.postSales.editClientDetails}`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    dispatch({ type: EDIT_CLIENT_DETAILS, payload });
    if (outer?.status === 0 || payload?.status === true) {
      return { status: true, message: payload?.message ?? outer?.message, data: payload?.data ?? outer?.data };
    }
    return { status: false, message: payload?.message ?? outer?.message, data: payload?.data ?? outer?.data };
  }
};

